document.addEventListener('DOMContentLoaded', function() {
     //////////// Header Menu
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const mainMenu = document.querySelector('.main-menu');
  
    if (mobileMenuToggle && mainMenu) {
        mobileMenuToggle.addEventListener('click', function() {
        mainMenu.classList.toggle('active');
        mobileMenuToggle.classList.toggle('active');
        });
    }
     ////////////  Header Menu  END


    ////////////  首页轮播特效
    // Initialize carousels
    initTopperCarousel();
    initCategoryCarousel();

    // Topper carousel initialization
    function initTopperCarousel() {
        const carousel = document.querySelector('.topper-carousel');
        if (!carousel) return;

        const slides = document.querySelector('.carousel-slides');
        const slideItems = document.querySelectorAll('.carousel-slide');
        const prevBtn = document.querySelector('.carousel-prev');
        const nextBtn = document.querySelector('.carousel-next');
        const indicators = document.querySelectorAll('.carousel-indicator');
        const playPauseBtn = document.querySelector('.play-pause-button');
        
        let currentIndex = 0;
        const slideCount = slideItems.length;
        let autoSlideInterval;
        let isPlaying = true;
        
        function updateCarousel() {
            // Update slides
            slideItems.forEach((slide, index) => {
            if (index === currentIndex) {
                slide.classList.add('active');
            } else {
                slide.classList.remove('active');
            }
            });
            
            // Update indicators
            indicators.forEach((indicator, index) => {
            if (index === currentIndex) {
                indicator.classList.add('active');
            } else {
                indicator.classList.remove('active');
            }
            });
        }
        
        function nextSlide() {
            currentIndex = (currentIndex + 1) % slideCount;
            updateCarousel();
        }
        
        function prevSlide() {
            currentIndex = (currentIndex - 1 + slideCount) % slideCount;
            updateCarousel();
        }
        
        function startAutoSlide() {
            if (slideCount > 1 && !autoSlideInterval) {
            autoSlideInterval = setInterval(nextSlide, 5000);
            isPlaying = true;
            updatePlayPauseButton();
            }
        }
        
        function stopAutoSlide() {
            if (autoSlideInterval) {
            clearInterval(autoSlideInterval);
            autoSlideInterval = null;
            isPlaying = false;
            updatePlayPauseButton();
            }
        }
        
        function updatePlayPauseButton() {
            if (playPauseBtn) {
            const playIcon = playPauseBtn.querySelector('.splide__toggle__play');
            const pauseIcon = playPauseBtn.querySelector('.splide__toggle__pause');
            
            if (isPlaying) {
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'flex';
            } else {
                playIcon.style.display = 'flex';
                pauseIcon.style.display = 'none';
            }
            }
        }
        
        // Event listeners
        if (nextBtn) {
            nextBtn.addEventListener('click', nextSlide);
        }
        if (prevBtn) {
            prevBtn.addEventListener('click', prevSlide);
        }
        
        // Indicator clicks
        if (indicators.length > 0) {
            indicators.forEach((indicator, index) => {
            indicator.addEventListener('click', () => {
                currentIndex = index;
                updateCarousel();
            });
            });
        }
        
        // Play/pause button
        if (playPauseBtn) {
            playPauseBtn.addEventListener('click', () => {
            if (isPlaying) {
                stopAutoSlide();
            } else {
                startAutoSlide();
            }
            });
        }
        
        // Handle window resize
        window.addEventListener('resize', function() {
            // Check if it's mobile device
            const isMobile = window.innerWidth <= 1024;
            
            // Update all slides to use correct styles based on device type
            slideItems.forEach(slide => {
                if (isMobile) {
                    slide.style.marginLeft = 'initial';
                    slide.style.width = '170vw';
                } else {
                    slide.style.marginLeft = '150px';
                    slide.style.width = '120rem';
                }
            });
        });
        
        // Initial update
        updateCarousel();
        updatePlayPauseButton();
        
        // Wait for first slide to show as full image, then start auto slide
        if (slideCount > 1) {
            setTimeout(() => {
                // Remove initial full image styles from first slide and set polygon shape
                const firstSlide = slideItems[0];
                
                // Check if it's mobile device
                const isMobile = window.innerWidth <= 1024;
                
                // Set different styles based on device type
                if (isMobile) {
                    firstSlide.style.clipPath = 'polygon(0 0, 58.9% 0, 79.5% 41.5%, 50% 100%, 50% 100%)';
                    firstSlide.style.marginLeft = 'initial';
                    firstSlide.style.marginRight = '0';
                    firstSlide.style.zIndex = '1';
                    firstSlide.style.transform = 'translateX(0)';
                    firstSlide.style.left = '0';
                    firstSlide.style.position = 'static';
                    firstSlide.style.maxWidth = 'none';
                    firstSlide.style.width = '170vw';
                    firstSlide.style.height = 'auto';
                    firstSlide.style.transition = 'clip-path 0.8s 0.2s, transform 0.8s 0.2s, opacity 0.5s ease-in-out, margin 0.8s 0.2s, visibility 0.8s 0.2s, width 0.8s 0.2s, left 0.8s 0.2s';
                } else {
                    firstSlide.style.clipPath = 'polygon(0 0, 58.9% 0, 79.5% 41.5%, 50% 100%, 50% 100%)';
                    firstSlide.style.marginLeft = '150px';
                    firstSlide.style.marginRight = '0';
                    firstSlide.style.zIndex = '1';
                    firstSlide.style.transform = 'translateX(0)';
                    firstSlide.style.left = '0';
                    firstSlide.style.position = 'static';
                    firstSlide.style.maxWidth = 'none';
                    firstSlide.style.width = '120rem';
                    firstSlide.style.height = 'auto';
                    firstSlide.style.transition = 'clip-path 0.8s 0.2s, transform 0.8s 0.2s, opacity 0.5s ease-in-out, margin 0.8s 0.2s, visibility 0.8s 0.2s, width 0.8s 0.2s, left 0.8s 0.2s';
                }
                
                // Show topper-content when image transitions to polygon shape
                const topperContent = document.querySelector('.topper-content');
                if (topperContent) {
                    topperContent.style.opacity = '1';
                }
                
                // Start auto slide after the transition
                setTimeout(() => {
                    startAutoSlide();
                }, 1000);
            }, 3000); // Show full image for 3 seconds
        } else {
            // If only one slide, show content immediately and start auto slide
            const topperContent = document.querySelector('.topper-content');
            if (topperContent) {
                topperContent.style.opacity = '1';
            }
            startAutoSlide();
        }
    }
    ////////////  首页轮播特效 EMD

    //////////// Category carousel initialization
    function initCategoryCarousel() {
        const carousel = document.querySelector('.category-carousel');
        if (!carousel) return;

        const slides = document.querySelector('.category-carousel-slides');
        const slideItems = document.querySelectorAll('.category-carousel-slide');
        const prevBtn = document.querySelector('.category-carousel-prev');
        const nextBtn = document.querySelector('.category-carousel-next');
        
        let currentIndex = 0;
        const slideCount = slideItems.length;
        
        function getSlidesPerView() {
            if (window.innerWidth <= 480) {
            return 1;
            } else if (window.innerWidth <= 768) {
            return 2;
            } else if (window.innerWidth <= 1024) {
            return 3;
            } else {
            return 4;
            }
        }
        
        function updateCarousel() {
            const slidesPerView = getSlidesPerView();
            const slideWidth = 100 / slidesPerView;
            const maxIndex = Math.max(0, slideCount - slidesPerView);
            
            // Ensure currentIndex doesn't exceed maxIndex
            currentIndex = Math.min(currentIndex, maxIndex);
            
            slides.style.transform = `translateX(-${currentIndex * slideWidth}%)`;
        }
        
        function nextSlide() {
            const slidesPerView = getSlidesPerView();
            const maxIndex = Math.max(0, slideCount - slidesPerView);
            currentIndex = Math.min(currentIndex + 1, maxIndex);
            updateCarousel();
        }
        
        function prevSlide() {
            currentIndex = Math.max(currentIndex - 1, 0);
            updateCarousel();
        }
        
        // Event listeners
        if (nextBtn) {
            nextBtn.addEventListener('click', nextSlide);
        }
        if (prevBtn) {
            prevBtn.addEventListener('click', prevSlide);
        }
        
        // Auto slide
        const slidesPerView = getSlidesPerView();
        if (slideCount > slidesPerView) {
            setInterval(nextSlide, 5000);
        }
        
        // Handle window resize
        window.addEventListener('resize', updateCarousel);
        
        // Initial update
        updateCarousel();
    }
    //////////// Category carousel initialization EMD

    ////////////  Video Modal Functionality
    const videoModal = document.getElementById('videoModal');
    const modalVideo = document.getElementById('modalVideo');
    const videoModalClose = document.querySelector('.video-modal-close');
    const videoItems = document.querySelectorAll('.video-item');

    // Open modal when video is clicked
    videoItems.forEach(item => {
    item.addEventListener('click', function() {
        const videoId = this.getAttribute('data-video-id');
        const videoType = this.getAttribute('data-video-type');
        
        if (videoType === 'youtube') {
        modalVideo.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        } else {
        // For uploaded videos, we'll use a simple iframe embed
        modalVideo.src = videoId;
        }
        
        videoModal.style.display = 'block';
    });
    });

    // Close modal when close button is clicked
    if (videoModalClose) {
    videoModalClose.addEventListener('click', function() {
        modalVideo.src = ''; // Stop video playback
        videoModal.style.display = 'none';
    });
    }

    // Close modal when clicking outside the modal content
    window.addEventListener('click', function(event) {
    if (event.target === videoModal) {
        modalVideo.src = ''; // Stop video playback
        videoModal.style.display = 'none';
    }
    });
    ////////////  Video Modal Functionality END
    
    ////////////文章详情页框架实现右侧特效
    // 仅在桌面端（宽度 > 1024px）生效
    const DESKTOP_BREAKPOINT = 1024;
    const sidebarRight = document.getElementById('article-sidebar-right');
    const articleBody = document.querySelector('.article-body');
    
    if (sidebarRight && articleBody) {
      let sidebarWidth, initialLeft, initialTop, sidebarHeight, elementBottom;
      let isInitialized = false;
      
      // 节流函数
      function throttle(func, delay) {
        let timeoutId;
        return function() {
          if (!timeoutId) {
            timeoutId = setTimeout(() => {
              func.apply(this, arguments);
              timeoutId = null;
            }, delay);
          }
        };
      }
      
      // 检查是否为桌面端
      function isDesktop() {
        return window.innerWidth > DESKTOP_BREAKPOINT;
      }
      
      // 移除固定样式
      function resetSidebarStyles() {
        sidebarRight.style.cssText = '';
      }
      
      // 初始化位置信息
      function initPositionInfo() {
        if (!isDesktop()) return;
        
        const parentElement = sidebarRight.parentElement;
        sidebarWidth = parentElement.offsetWidth;
        
        const initialRect = sidebarRight.getBoundingClientRect();
        initialLeft = initialRect.left;
        initialTop = window.pageYOffset + initialRect.top;
        sidebarHeight = initialRect.height;
        elementBottom = initialTop + sidebarHeight;
      }
      
      // 获取 article-body 位置信息
      function getArticleBodyPosition() {
        const rect = articleBody.getBoundingClientRect();
        return {
          top: window.pageYOffset + rect.top,
          bottom: window.pageYOffset + rect.top + rect.height
        };
      }
      
      // 检查滚动位置的函数
      function checkScrollPosition() {
        // 移动端不执行
        if (!isDesktop()) {
          resetSidebarStyles();
          return;
        }
        
        // 如果未初始化或元素不可见，重新初始化
        if (!isInitialized || sidebarHeight === 0) {
          initPositionInfo();
          isInitialized = true;
        }
        
        // 获取当前滚动位置
        const scrollTop = window.pageYOffset;
        // 获取视口高度
        const viewportHeight = window.innerHeight;
        // 计算当前视口底部相对于文档的位置
        const viewportBottom = scrollTop + viewportHeight;
        // 获取 article-body 位置
        const articleBodyPos = getArticleBodyPosition();
        
        // 当视口底部超过元素底部时
        if (viewportBottom >= elementBottom) {
          // 计算固定定位的位置
          let fixedBottom = 0;
          
          // 如果滚动超出 article-body 范围，计算超出的距离
          if (viewportBottom > articleBodyPos.bottom) {
            // 计算超出的距离
            const overflow = viewportBottom - articleBodyPos.bottom;
            // 调整固定位置，使侧边栏保持在 article-body 底部
            fixedBottom = overflow;
          }
          
          // 直接设置所有样式，使用初始左侧位置
          sidebarRight.style.cssText = `
            position: fixed;
            width: ${sidebarWidth}px;
            bottom: ${fixedBottom}px;
            top: auto;
            z-index: 100;
            left: ${initialLeft}px;
          `;
        } else {
          // 移除所有样式
          resetSidebarStyles();
        }
      }
      
      // 初始化
      initPositionInfo();
      checkScrollPosition();
      
      // 添加滚动事件监听（使用节流优化）
      window.addEventListener('scroll', throttle(checkScrollPosition, 16));
      
      // 监听窗口大小变化（使用节流优化）
      window.addEventListener('resize', throttle(function() {
        if (isDesktop()) {
          // 桌面端：重新初始化并检查
          isInitialized = false;
          initPositionInfo();
          checkScrollPosition();
        } else {
          // 移动端：移除所有固定样式
          resetSidebarStyles();
        }
      }, 16));
    }
    ////////////文章详情页框架实现右侧特效   END
    
});